var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classButton + 'svg-arrow-container',on:{"click":function($event){return _vm.action()}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16.4","height":"16.1","viewBox":"0 0 9.4 6.1"}},[_c('path',{attrs:{"d":"M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z","transform":"translate(-2 -2)"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }